import {
	ExcludeLocationsModel,
	ExecutePharmacyIdBulkReviewActionModel,
	PharmacyIdReviewActionModel,
	RebateInvalidRecordsResolveModel,
	ApplyConversionCoefficientModel,
	CheckResultModel,
	ConversionHistoryModel,
	DeleteFileInvalidRecordsByErrorCodeModel,
	ExecuteAggregationModel,
	ExecuteConversionModel,
	FileDuplicateRebateRecordModel,
	FilterBulkUpdateRequest,
	FilterSearchRequest,
	InvalidRebateRecordSearchModel,
	ListOptionModel,
	MappingPreviewFilterModel,
	MarkFilteredAsDeletedModel,
	NdcJCodeExclusionModel,
	ProcessRebateLoadFileModel,
	ReadRebateLoadFileModel,
	RebateLoadAggregationModel,
	RebateLoadBaseSearchFilterModel,
	RebateLoadConversionModel,
	RebateLoadConvertedModel,
	RebateLoadFileDetailedListOptionModel,
	RebateLoadFilePeriod,
	RebateLoadFileSheetModel,
	RebateLoadFilesDetailedOptionsRequest,
	RebateLoadFilesOptionsRequest,
	RebateRecordDuplicatePairModel,
	RebateRecordGroupedErrorsModel,
	RebatesInvalidRecordsUpdateModel,
	RebatesLoadAggregationOptionsGroupModel,
	RebatesLoadConversionOptionsGroupModel,
	RebatesLoadFileDetailsModel,
	RebatesLoadFileSearchFilterModel,
	RebatesLoadInvalidRecordsBulkFilterModel,
	RebatesLoadInvalidRecordsFilterModel,
	RebatesLoadMappingModel,
	RebatesLoadStatistic,
	RebatesLoadTemplateSaveModel,
	RebatesLoadTemplateDeleteModel,
	RecoveryJCodesModel,
	RecoveryNdcJCodeCoefficientsModel,
	ResolveAberrantQuantityRecordsModel,
	ResolveAllDuplicateModel,
	ResolveAllFileDuplicateModel,
	ResolveDuplicateModel,
	ResolveFileDuplicateModel,
	SearchResponse,
	SetConversionQuantityModel,
	UnknownJCodeDetailsModel,
	UnmappedRebateLoadLocationModel,
	UpdateMappingModel,
	UpdateNdcJCodeExclusionsModel,
	RecordsValidationResultModel,
	ReviewedPharmacyIdItemModel,
	NotReviewedPharmacyIdSearchModel,
	ChangeSubmissionPeriodRequest,
	ResolveFilteredAberrantQuantityRecordsModel,
	RebateLoadConvertedSearchFilterModel,
	RebateLoadStatusChangedNotification,
	RebateLoadFileCreatedNotification,
	RebateLoadStatisticUpdatedNotification,
	RebateLoadMappingSuggestedNotification,
	RebateLoadConversionSuggestedNotification,
	RebateLoadMappingSuggestionModel,
	FileRollbackModel,
	RawRebateRecordsSearchFilterModel,
	RawRebateRecordModel,
	RebateLoadMissingLocationSearchModel,
	CustomerRebateLoadLocationModel,
	RebateLoadMultiprocessingFilesDetailsModel,
	RebateLoadMultiprocessingRequestModel,
	RebatesLoadFilesStatisticRequest,
	PharmacyIdNotReviewedGroupsFilterModel,
	CheckFilesLocationsValidRequestModel,
	RebateLoadMultiprocessingBaseSearchFilterModel,
	RebateLoadMultiprocessingValidationModel,
	RebateLoadNotConvertedSearchFilterModel,
	AberrantQuantityRecordsCountsModel,
	RebateInvalidRecordsCountFilterModel,
	RebateLoadConversionBaseSearchFilterModel,
	ExcludeAllCustomerLocationsModel,
	NdcJCodeExclusionSearchModel,
	RebateLoadFileValidationModel,
	ExtensionMappingConfigModel
} from '@twrx-api-models';
import { createAction, props } from '@ngrx/store';
import { NotConvertedRebateLoadTableModel } from 'app/models/dto/not-converted-rebate-load-table-model';
import { RebatesUploadModel } from 'app/models/dto/rebates-upload-model';
import { RebatesLoadFileSearchStoreModel } from 'app/models/dto/rebates-load-file-search-store-model';

import { ActionRequestPayload } from '../action-request-payload';
import { ActionResponsePayload } from '../action-response-payload';

export enum RebatesLoadActions {
	LoadRebatesLoadFiles = '[RebateLoad] LoadRebatesLoadFiles',
	RebatesLoadFilesLoaded = '[RebateLoad] RebatesLoadFilesLoaded',

	LoadConvertedRebateLoad = '[RebateLoad] LoadConvertedRebateLoad',
	ConvertedRebateLoadLoaded = '[RebateLoad] ConvertedRebateLoadLoaded',

	LoadNotConvertedRebateLoad = '[RebateLoad] LoadNotConvertedRebateLoad',
	NotConvertedRebateLoadLoaded = '[RebateLoad] NotConvertedRebateLoadLoaded',

	LoadRebateLoadConversions = '[RebateLoad] LoadRebateLoadConversions',
	RebateLoadConversionsLoaded = '[RebateLoad] RebateLoadConversionsLoaded',

	ResetRecommendedConversion = '[RebateLoad] ResetRecommendedConversion',

	LoadRebateLoadAggregations = '[RebateLoad] LoadRebateLoadAggregations',
	RebateLoadAggregationsLoaded = '[RebateLoad] RebateLoadAggregationsLoaded',

	ExecuteRebateLoadAggregation = '[RebateLoad] ExecuteRebateLoadAggregation',
	RebateLoadAggregated = '[RebateLoad] RebateLoadAggregated',

	ResolveDuplicates = '[RebateLoad] ResolveDuplicates',
	DuplicatesResolved = '[RebateLoad] DuplicatesResolved',

	ResolveAllDuplicates = '[RebateLoad] ResolveAllDuplicates',
	AllDuplicatesResolved = '[RebateLoad] AllDuplicatesResolved',

	ResolveFileDuplicates = '[RebateLoad] ResolveFileDuplicates',
	FileDuplicatesResolved = '[RebateLoad] FileDuplicatesResolved',

	ResolveAllFileDuplicates = '[RebateLoad] ResolveAllFileDuplicates',
	AllFileDuplicatesResolved = '[RebateLoad] AllFileDuplicatesResolved',

	ExecuteRebateLoadConversion = '[RebateLoad] ExecuteRebateLoadConversion',
	ExecuteCurrentRebateLoadConversion = '[RebateLoad] ExecuteCurrentRebateLoadConversion',
	RebateLoadConversionExecuted = '[RebateLoad] RebateLoadConversionExecuted',

	SetRebateLoadQuantities = '[RebateLoad] SetRebateLoadQuantities',
	RebateLoadQuantitiesSetted = '[RebateLoad] RebateLoadQuantitiesSetted',

	ExecuteProcessRebateLoadFile = '[RebateLoad] ExecuteProcessRebateLoadFile',
	ProcessRebateLoadFileExecuted = '[RebateLoad] ProcessRebateLoadFileExecuted',

	ResetRebateLoadConversionType = '[RebateLoad] ResetRebateLoadConversionType',
	RebateLoadConversionTypeReseted = '[RebateLoad] RebateLoadConversionTypeReseted',

	LoadRebatesLoadFileStatistic = '[RebateLoad] LoadRebatesLoadFileStatistic',
	RebatesLoadFileStatisticNotFound = '[RebateLoad] RebatesLoadFileStatisticNotFound',
	RebatesLoadFileStatisticLoaded = '[RebateLoad] RebatesLoadFileStatisticLoaded',

	LoadRawRebateRecords = '[RebateLoad] LoadRawRebateRecords',
	RawRebateRecordsLoaded = '[RebateLoad] RawRebateRecordsLoaded',

	LoadRebateRecordDuplicates = '[RebateLoad] LoadRebateRecordDuplicates',
	RebateRecordDuplicatesLoaded = '[RebateLoad] RebateRecordDuplicatesLoaded',

	LoadRebateRecordFileDuplicates = '[RebateLoad] LoadRebateRecordFileDuplicates',
	ClearRebateRecordFileDuplicates = '[RebateLoad] ClearRebateRecordFileDuplicates',
	RebateRecordFileDuplicatesLoaded = '[RebateLoad] RebateRecordFileDuplicatesLoaded',

	PreloadRebatesLoadFileDetails = '[RebateLoad] PreloadRebatesLoadFileDetails',
	PreloadedRebatesLoadFileNotFound = '[RebateLoad] PreloadedRebatesLoadFileNotFound',
	RebatesLoadFileDetailsPreloaded = '[RebateLoad] RebatesLoadFileDetailsPreloaded',

	LoadRebatesLoadFileDetails = '[RebateLoad] LoadRebatesLoadFileDetails',
	LoadedRebatesLoadFileNotFound = '[RebateLoad] LoadedRebatesLoadFileNotFound',
	RebatesLoadFileDetailsLoaded = '[RebateLoad] RebatesLoadFileDetailsLoaded',
	ClearRebatesLoadFileDetails = '[RebatesLoad] ClearRebatesLoadFileDetails',

	LoadRebatesLoadMultiprocessingFilesDetails = '[RebateLoad] LoadRebatesLoadMultiprocessingFilesDetails',
	RebatesLoadMultiprocessingFilesDetailsLoaded = '[RebateLoad] RebatesLoadMultiprocessingFilesDetailsLoaded',

	ValidateGroupsOnMultiprocessing = '[RebateLoad] ValidateGroupsOnMultiprocessing',
	GroupsValidatedOnMultiprocessing = '[RebateLoad] GroupsValidatedOnMultiprocessing',

	DeleteRebateLoadFile = '[RebateLoad] DeleteRebateLoadFile',
	RebatesLoadFileDeleted = '[RebateLoad] RebatesLoadFileDeleted',

	AddRebatesLoadFile = '[RebateLoad] AddRebatesLoadFile',
	RebatesLoadFileLoading = '[RebateLoad] RebatesLoadFileLoading',
	RebatesLoadFileAdded = '[RebateLoad] RebatesLoadFileAdded',

	LoadRebatesLoadTemplates = '[RebateLoad] LoadRebatesLoadTemplates',
	RebatesLoadTemplatesLoaded = '[RebateLoad] RebatesLoadTemplatesLoaded',

	LoadRebateLoadFilesOptions = '[RebateLoad] LoadRebateLoadFilesOptions',
	RebateLoadFilesOptionsLoaded = '[RebateLoad] RebateLoadFilesOptionsLoaded',

	LoadRebateLoadFilesDetailedOptions = '[RebateLoad] LoadRebateLoadFilesDetailedOptions',
	RebateLoadFilesDetailedOptionsLoaded = '[RebateLoad] RebateLoadFilesDetailedOptionsLoaded',

	LoadRebatesLoadTemplateMapping = '[RebateLoad] LoadRebatesLoadTemplateMapping',
	RebatesLoadTemplateMappingLoaded = '[RebateLoad] RebatesLoadTemplateMappingLoaded',

	SaveRebatesLoadTemplate = '[RebateLoad] SaveRebatesLoadTemplate',
	RebatesLoadTemplateSaved = '[RebateLoad] RebatesLoadTemplateSaved',

	DeleteRebatesLoadTemplate = '[RebateLoad] DeleteRebatesLoadTemplate',
	RebatesLoadTemplateDeleted = '[RebateLoad] RebatesLoadTemplateDeleted',

	ProcessRebatesLoadFile = '[RebateLoad] ProcessRebatesLoadFile',
	RebatesLoadFileProcessed = '[RebateLoad] RebatesLoadFileProcessed',

	LoadRebatesInvalidRecords = '[RebateLoad] LoadRebatesInvalidRecords',
	RebatesInvalidRecordsLoaded = '[RebateLoad] RebatesInvalidRecordsLoaded',

	LoadRebatesInvalidRecordsBulkCount = '[RebateLoad] LoadRebatesInvalidRecordsBulkCount',
	RebatesInvalidRecordsBulkCountLoaded = '[RebateLoad] RebatesInvalidRecordsBulkCountLoaded',

	StartRebatesInvalidRecordsFileGeneration = '[RebateLoad] StartRebatesInvalidRecordsFileGeneration',
	RebatesInvalidRecordsFileGenerationStarted = '[RebateLoad] RebatesInvalidRecordsFileGenerationStarted',

	LoadRebatesGroupedErrors = '[RebateLoad] LoadRebatesGroupedErrors',
	RebatesGroupedErrorsLoaded = '[RebateLoad] RebatesGroupedErrorsLoaded',
	RebatesGroupedWarningsLoaded = '[RebateLoad] RebatesGroupedWarningsLoaded',
	ClearRebatesGroupedErrorsWarnings = '[RebatesLoad] ClearRebatesGroupedErrors',

	StartRebateLoadFileInvalidRecordsResolving = '[RebateLoad] ResolveRebateLoadFileInvalidRecords',
	RebatesLoadFileInvalidRecordsResolvingStarted = '[RebateLoad] RebatesLoadFileInvalidRecordsResolved',

	DeleteRebateLoadFileInvalidRecordsByErrorCode = '[RebateLoad] DeleteRebateLoadFileInvalidRecordsByErrorCode',
	RebatesLoadFileInvalidRecordsByErrorCodeDeleted = '[RebateLoad] RebatesLoadFileInvalidRecordsByErrorCodeDeleted',

	StartBulkUpdateInvalidRecords = '[RebateLoad] StartBulkUpdateInvalidRecords',
	InvalidRecordsBulkUpdateStarted = '[RebateLoad] InvalidRecordsBulkUpdateStarted',

	StartRebatesLoadFileReading = '[RebateLoad] StartRebatesLoadFileReading',
	RebatesLoadFileReadingStarted = '[RebateLoad] RebatesLoadFileReadingStarted',

	StartUpdatedRebatesRecordsValidation = '[RebateLoad] StartUpdatedRebatesRecordsValidation',
	UpdatedRebatesRecordsValidationStarted = '[RebateLoad] UpdatedRebatesRecordsValidationStarted',
	ValidateRebateLoadFile = '[RebateLoad] ValidateRebateLoadFile',
	RebateLoadFileValidated = '[RebateLoad] RebateLoadFileValidated',

	ApplyRebateLoadCoefficient = '[RebateLoad] ApplyRebateLoadCoefficient',
	RebateLoadCoefficientApplied = '[RebateLoad] RebateLoadCoefficientApplied',

	LoadRebatesLoadRecentAggregationOptions = '[RebateLoad] LoadRebatesLoadRecentAggregationOptions',
	RebatesLoadRecentAggregationOptionsLoaded = '[RebateLoad] RebatesLoadRecentAggregationOptionsLoaded',

	LoadRebatesLoadRecentConversionOptions = '[RebateLoad] LoadRebatesLoadRecentConversionOptions',
	RebatesLoadRecentConversionOptionsLoaded = '[RebateLoad] RebatesLoadRecentConversionOptionsLoaded',

	LoadRebateLoadFilePreviousPeriod = '[RebateLoad] LoadRebateLoadFilePreviousPeriod',
	RebateLoadFilePreviousPeriodLoaded = '[RebateLoad] RebateLoadFilePreviousPeriodLoaded',

	LoadNotReviewedLocations = '[RebateLoad] LoadNotReviewedLocations',
	NotReviewedLocationLoaded = '[RebateLoad] NotReviewedLocationLoaded',

	LoadCustomerLocations = '[RebateLoad] LoadCustomerLocations',
	CustomerLocationLoaded = '[RebateLoad] CustomerLocationLoaded',

	LoadMissingLocations = '[RebateLoad] LoadMissingLocations',
	MissingLocationsLoaded = '[RebateLoad] MissingLocationsLoaded',

	ExcludeLocations = '[RebateLoad] ExcludeLocation',
	LocationExcluded = '[RebateLoad] LocationExcluded',
	LocationsExcluded = '[RebateLoad] LocationsExcluded',

	StartAllLocationsExcluding = '[RebateLoad] StartAllLocationsExcluding',
	AllLocationsExcludingStarted = '[RebateLoad] AllLocationsExcludingStarted',

	CheckLocationsBulkActionLoading = '[RebateLoad] CheckLocationsBulkActionLoading',
	LocationsBulkActionLoadingChecked = '[RebateLoad] LocationsBulkActionLoadingChecked',

	LocationsBulkOperationFinished = '[RebateLoad] LocationsBulkOperationFinished',

	StartNotReviewedLocationsFileGeneration = '[RebateLoad] StartNotReviewedLocationsFileGeneration',
	NotReviewedLocationsFileGenerationStarted = '[RebateLoad] NotReviewedLocationsFileGenerationStarted',

	UpdateRebateLoadMapping = '[RebateLoad] UpdateRebateLoadMapping',
	RebateLoadMappingUpdated = '[RebateLoad] RebateLoadMappingUpdated',

	SetTableFilters = '[RebateLoad] SetTableFilters',
	TableFiltersSet = '[RebateLoad] TableFiltersSet',

	LoadUnknownJCodeDetails = '[RebateLoad] LoadUnknownJCodeDetails',
	UnknownJCodeDetailsLoaded = '[RebateLoad] UnknownJCodeDetailsLoaded',

	RecoveryJCodes = '[RebateLoad] RecoveryJCodes',
	JCodesRecovered = '[RebateLoad] JCodesRecovered',

	RecoveryNdcJCodeCoefficients = '[RebateLoad] RecoveryNdcJCodeCoefficients',
	NdcJCodeCoefficientsRecovered = '[RebateLoad] NdcJCodeCoefficientsRecovered',

	LoadNdcJCodeExclusions = '[RebateLoad] LoadNdcJCodeExclusions',
	NdcJCodeExclusionsLoaded = '[RebateLoad] NdcJCodeExclusionsLoaded',

	UpdateNdcJCodeExclusions = '[RebateLoad] UpdateNdcJCodeExclusions',
	NdcJCodeExclusionsUpdated = '[RebateLoad] NdcJCodeExclusionsUpdated',

	LoadConversionHistory = '[RebateLoad] LoadConversionHistory',
	ConversionHistoryLoaded = '[RebateLoad] ConversionHistoryLoaded',

	StartFileDuplicatesFileGeneration = '[RebateLoad] StartFileDuplicatesFileGeneration',
	FileDuplicatesFileGenerationStarted = '[RebateLoad] FileDuplicatesFileGenerationStarted',

	StartDuplicatesFileGeneration = '[RebateLoad] StartDuplicatesFileGeneration',
	DuplicatesFileGenerationStarted = '[RebateLoad] DuplicatesFileGenerationStarted',

	RevalidateRebateLoadFileRecords = '[RebateLoad] RevalidateRebateLoadFileRecords',
	RebateLoadFileRecordsRevalidated = '[RebateLoad] RebateLoadFileRecordsRevalidated',

	LoadFileMappingPreview = '[RebateLoad] LoadFileMappingPreview',
	FileMappingPreviewLoaded = '[RebateLoad] FileMappingPreviewLoaded',

	SuggestRebateLoadMapping = '[RebateLoad] SuggestRebateLoadMapping',
	RebateLoadMappingSuggestionStarted = '[RebateLoad] RebateLoadMappingSuggestionStarted',
	LoadSuggestedMapping = '[RebateLoad] LoadSuggestedMapping',
	RebateLoadMappingSuggestionLoaded = '[RebateLoad] RebateLoadMappingSuggestionLoaded',

	SuggestRebateLoadConversion = '[RebateLoad] SuggestRebateLoadConversion',
	RebateLoadConversionSuggestionStarted = '[RebateLoad] RebateLoadConversionSuggestionStarted',

	LoadExtensionMappingConfig = '[RebateLoad] LoadExtensionMappingConfig',
	ExtensionMappingConfigLoaded = '[RebateLoad] ExtensionMappingConfigLoaded',

	ClearRebateLoadIndicator = '[RebateLoad] ClearRebateLoadIndicator',

	MarkFilteredRecordsAsDeleted = '[RebateLoad] MarkFilteredRecordsAsDeleted',
	FilteredRecordsMarkedAsDeleted = '[RebateLoad] FilteredRecordsMarkedAsDeleted',

	LoadAberrantQuantityRecordsCounts = '[RebateLoad] LoadAberrantQuantityRecordsCounts',
	AberrantQuantityRecordsCountsLoaded = '[RebateLoad] AberrantQuantityRecordsCountsLoaded',

	ResolveAberrantQuantityRecords = '[RebateLoad] ResolveAberrantQuantityRecords',
	AberrantQuantityRecordsResolved = '[RebateLoad] AberrantQuantityRecordsResolved',

	ResolveFilteredAberrantQuantityRecords = '[RebateLoad] ResolveFilteredAberrantQuantityRecords',
	FilteredAberrantQuantityRecordsResolved = '[RebateLoad] FilteredAberrantQuantityRecordsResolved',

	LoadCurrentFileMapping = '[RebatesLoad] LoadCurrentFileMapping',
	CurrentFileMappingLoaded = '[RebatesLoad] CurrentFileMappingLoaded',

	LoadFileSheets = '[RebatesLoad] LoadFileSheets',
	FileSheetsLoaded = '[RebatesLoad] FileSheets',

	CheckFileLocationsValid = '[RebatesLoad] CheckFileLocationsValid',
	FileLocationsValidChecked = '[RebatesLoad] FileLocationsValidChecked',

	CheckFileDefinitionsResolved = '[RebatesLoad] CheckFileDefinitionsResolved',
	FileDefinitionsResolvedChecked = '[RebatesLoad] FileDefinitionsResolvedChecked',

	ValidatePharmacyIdItems = '[RebatesLoad] ValidatePharmacyIdItems',
	PharmacyIdItemsValidated = '[RebatesLoad] PharmacyIdItemsValidated',

	LoadNotReviewedPharmacyIdItems = '[RebatesLoad] LoadNotReviewedPharmacyIdItems',
	NotReviewedPharmacyIdReviewItemsLoaded = '[RebatesLoad] NotReviewedPharmacyIdReviewItemsLoaded',

	LoadNotReviewedPharmacyIdItemsAvailableActions = '[RebatesLoad] LoadNotReviewedPharmacyIdItemsAvailableActions',
	NotReviewedPharmacyIdReviewItemsAvailableActionsLoaded = '[RebatesLoad] NotReviewedPharmacyIdReviewItemsAvailableActionsLoaded',

	LoadReviewedPharmacyIdItems = '[RebatesLoad] LoadReviewedPharmacyIdItems',
	ReviewedPharmacyIdReviewItemsLoaded = '[RebatesLoad] ReviewedPharmacyIdReviewItemsLoaded',

	ExecutePharmacyIdReviewBulkAction = '[RebatesLoad] ExecutePharmacyIdReviewBulkAction',
	PharmacyIdReviewBulkActionExecuted = '[RebatesLoad] PharmacyIdReviewBulkActionExecuted',

	ChangeSubmissionPeriod = '[RebateLoad] ChangeSubmissionPeriod',
	SubmissionPeriodChanged = '[RebateLoad] SubmissionPeriodChanged',

	RebateLoadStatusUpdatedEvent = '[RebateLoad] [Event] RebateLoadStatusUpdatedEvent',
	RebateLoadFileCreatedEvent = '[RebateLoad] [Event] RebateLoadFileCreatedEvent',
	RebateLoadStatisticUpdatedEvent = '[RebateLoad] [Event] RebateLoadStatisticUpdatedEvent',
	RebateLoadMappingSuggestedEvent = '[RebateLoad] [Event] RebateLoadMappingSuggestedEvent',
	RebateLoadConversionSuggestedEvent = '[RebateLoad] [Event] RebateLoadConversionSuggestedEvent',

	RollbackRebateLoadFile = '[RebateLoad] RollbackRebateLoadFile',
	RebateLoadFileRolledBack = '[RebateLoad] RebateLoadFileRolledBack',

	ExecuteSetFinalReviewForRebateLoadFile = '[RebateLoad] ExecuteSetFinalReviewForRebateLoadFile',
	SetFinalReviewForRebateLoadFileExecuted = '[RebateLoad] SetFinalReviewForRebateLoadFileExecuted',

	ErrorOccurred = '[RebatesLoad] ErrorOccurred'
}

export const loadRebatesLoadFiles = createAction(
	RebatesLoadActions.LoadRebatesLoadFiles,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebatesLoadFileSearchFilterModel>
		>
	>()
);

export const rebatesLoadFilesLoaded = createAction(
	RebatesLoadActions.RebatesLoadFilesLoaded,
	props<
		ActionResponsePayload<SearchResponse<RebatesLoadFileSearchStoreModel>>
	>()
);

export const loadRebateLoadAggregations = createAction(
	RebatesLoadActions.LoadRebateLoadAggregations,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const rebateLoadAggregationsLoaded = createAction(
	RebatesLoadActions.RebateLoadAggregationsLoaded,
	props<ActionResponsePayload<SearchResponse<RebateLoadAggregationModel>>>()
);

export const loadRawRebateRecords = createAction(
	RebatesLoadActions.LoadRawRebateRecords,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RawRebateRecordsSearchFilterModel>
		>
	>()
);

export const rawRebateRecordsLoaded = createAction(
	RebatesLoadActions.RawRebateRecordsLoaded,
	props<ActionResponsePayload<SearchResponse<RawRebateRecordModel>>>()
);

export const loadRebateLoadDuplicates = createAction(
	RebatesLoadActions.LoadRebateRecordDuplicates,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const rebateLoadDuplicatesLoaded = createAction(
	RebatesLoadActions.RebateRecordDuplicatesLoaded,
	props<
		ActionResponsePayload<SearchResponse<RebateRecordDuplicatePairModel>>
	>()
);

export const loadRebateLoadFileDuplicates = createAction(
	RebatesLoadActions.LoadRebateRecordFileDuplicates,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const clearRebateLoadFileDuplicates = createAction(
	RebatesLoadActions.ClearRebateRecordFileDuplicates
);

export const rebateLoadFileDuplicatesLoaded = createAction(
	RebatesLoadActions.RebateRecordFileDuplicatesLoaded,
	props<
		ActionResponsePayload<SearchResponse<FileDuplicateRebateRecordModel>>
	>()
);

export const executeRebateLoadAggregation = createAction(
	RebatesLoadActions.ExecuteRebateLoadAggregation,
	props<ActionRequestPayload<ExecuteAggregationModel>>()
);

export const rebateLoadAggregationExecuted = createAction(
	RebatesLoadActions.RebateLoadAggregated
);

export const executeRebateLoadConversion = createAction(
	RebatesLoadActions.ExecuteRebateLoadConversion,
	props<ActionRequestPayload<ExecuteConversionModel>>()
);

export const executeCurrentRebateLoadConversion = createAction(
	RebatesLoadActions.ExecuteCurrentRebateLoadConversion,
	props<ActionRequestPayload<number[]>>()
);

export const rebateLoadConversionExecuted = createAction(
	RebatesLoadActions.RebateLoadConversionExecuted
);

export const resolveDuplicates = createAction(
	RebatesLoadActions.ResolveDuplicates,
	props<ActionRequestPayload<ResolveDuplicateModel>>()
);

export const duplicatesResolved = createAction(
	RebatesLoadActions.DuplicatesResolved,
	props<ActionResponsePayload<RecordsValidationResultModel>>()
);

export const resolveAllDuplicates = createAction(
	RebatesLoadActions.ResolveAllDuplicates,
	props<ActionRequestPayload<ResolveAllDuplicateModel>>()
);

export const allDuplicatesResolved = createAction(
	RebatesLoadActions.AllDuplicatesResolved
);

export const resolveFileDuplicates = createAction(
	RebatesLoadActions.ResolveFileDuplicates,
	props<ActionRequestPayload<ResolveFileDuplicateModel>>()
);

export const fileDuplicatesResolved = createAction(
	RebatesLoadActions.FileDuplicatesResolved
);

export const resolveAllFileDuplicates = createAction(
	RebatesLoadActions.ResolveAllFileDuplicates,
	props<ActionRequestPayload<ResolveAllFileDuplicateModel>>()
);

export const allFileDuplicatesResolved = createAction(
	RebatesLoadActions.AllFileDuplicatesResolved
);

export const applyRebateLoadCoefficient = createAction(
	RebatesLoadActions.ApplyRebateLoadCoefficient,
	props<ActionRequestPayload<ApplyConversionCoefficientModel>>()
);

export const rebateLoadCoefficientApplied = createAction(
	RebatesLoadActions.RebateLoadCoefficientApplied
);

export const setRebateLoadQuantities = createAction(
	RebatesLoadActions.SetRebateLoadQuantities,
	props<ActionRequestPayload<SetConversionQuantityModel>>()
);

export const rebateLoadQuantitiesSetted = createAction(
	RebatesLoadActions.RebateLoadQuantitiesSetted,
	props<ActionResponsePayload<RecordsValidationResultModel>>()
);

export const resetRebateLoadConversionType = createAction(
	RebatesLoadActions.ResetRebateLoadConversionType,
	props<ActionRequestPayload<number[]>>()
);

export const rebateLoadConversionTypeReseted = createAction(
	RebatesLoadActions.RebateLoadConversionTypeReseted,
	props<ActionResponsePayload<number[]>>()
);

export const resetRecommendedConversion = createAction(
	RebatesLoadActions.ResetRecommendedConversion
);

export const loadRebatesLoadConversions = createAction(
	RebatesLoadActions.LoadRebateLoadConversions,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadConversionBaseSearchFilterModel>
		>
	>()
);

export const rebatesLoadConversionsLoaded = createAction(
	RebatesLoadActions.RebateLoadConversionsLoaded,
	props<ActionResponsePayload<SearchResponse<RebateLoadConversionModel>>>()
);

export const loadConvertedRebatesLoad = createAction(
	RebatesLoadActions.LoadConvertedRebateLoad,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadConvertedSearchFilterModel>
		>
	>()
);

export const convertedRebatesLoadLoaded = createAction(
	RebatesLoadActions.ConvertedRebateLoadLoaded,
	props<ActionResponsePayload<SearchResponse<RebateLoadConvertedModel>>>()
);

export const loadNotConvertedRebatesLoad = createAction(
	RebatesLoadActions.LoadNotConvertedRebateLoad,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadNotConvertedSearchFilterModel>
		>
	>()
);

export const notConvertedRebatesLoadLoaded = createAction(
	RebatesLoadActions.NotConvertedRebateLoadLoaded,
	props<
		ActionResponsePayload<SearchResponse<NotConvertedRebateLoadTableModel>>
	>()
);

export const processRebateLoadFile = createAction(
	RebatesLoadActions.ExecuteProcessRebateLoadFile,
	props<ActionRequestPayload<ProcessRebateLoadFileModel>>()
);

export const processRebateLoadFileExecuted = createAction(
	RebatesLoadActions.ProcessRebateLoadFileExecuted
);

export const loadRebatesLoadFileStatistic = createAction(
	RebatesLoadActions.LoadRebatesLoadFileStatistic,
	props<ActionRequestPayload<RebatesLoadFilesStatisticRequest>>()
);

export const rebatesLoadFileStatisticNotFound = createAction(
	RebatesLoadActions.RebatesLoadFileStatisticNotFound
);

export const rebatesLoadFileStatisticLoaded = createAction(
	RebatesLoadActions.RebatesLoadFileStatisticLoaded,
	props<ActionResponsePayload<RebatesLoadStatistic>>()
);

export const preloadRebatesLoadFileDetails = createAction(
	RebatesLoadActions.PreloadRebatesLoadFileDetails,
	props<ActionRequestPayload<number>>()
);

export const preloadedRebatesLoadFileNotFound = createAction(
	RebatesLoadActions.PreloadedRebatesLoadFileNotFound
);

export const rebatesLoadFileDetailsPreloaded = createAction(
	RebatesLoadActions.RebatesLoadFileDetailsPreloaded,
	props<ActionResponsePayload<RebatesLoadFileDetailsModel>>()
);

export const loadRebatesLoadFileDetails = createAction(
	RebatesLoadActions.LoadRebatesLoadFileDetails,
	props<ActionRequestPayload<number>>()
);

export const loadedRebatesLoadFileNotFound = createAction(
	RebatesLoadActions.LoadedRebatesLoadFileNotFound
);

export const rebatesLoadFileDetailsLoaded = createAction(
	RebatesLoadActions.RebatesLoadFileDetailsLoaded,
	props<ActionResponsePayload<RebatesLoadFileDetailsModel>>()
);

export const loadRebatesLoadMultiprocessingFilesDetails = createAction(
	RebatesLoadActions.LoadRebatesLoadMultiprocessingFilesDetails,
	props<ActionRequestPayload<RebateLoadMultiprocessingRequestModel>>()
);

export const rebatesLoadMultiprocessingFilesDetailsLoaded = createAction(
	RebatesLoadActions.RebatesLoadMultiprocessingFilesDetailsLoaded,
	props<ActionResponsePayload<RebateLoadMultiprocessingFilesDetailsModel>>()
);

export const validateGroupsOnMultiprocessing = createAction(
	RebatesLoadActions.ValidateGroupsOnMultiprocessing,
	props<ActionRequestPayload<RebateLoadMultiprocessingValidationModel>>()
);

export const groupsValidatedOnMultiprocessing = createAction(
	RebatesLoadActions.GroupsValidatedOnMultiprocessing,
	props<ActionResponsePayload<CheckResultModel>>()
);

export const clearRebatesLoadFileDetails = createAction(
	RebatesLoadActions.ClearRebatesLoadFileDetails
);

export const deleteRebateLoadFile = createAction(
	RebatesLoadActions.DeleteRebateLoadFile,
	props<ActionRequestPayload<number>>()
);

export const rebatesLoadFileDeleted = createAction(
	RebatesLoadActions.RebatesLoadFileDeleted,
	props<ActionRequestPayload<number>>()
);

export const addRebatesLoadFile = createAction(
	RebatesLoadActions.AddRebatesLoadFile,
	props<ActionRequestPayload<RebatesUploadModel>>()
);

export const rebatesLoadFileLoading = createAction(
	RebatesLoadActions.RebatesLoadFileLoading,
	props<ActionResponsePayload<number>>()
);

export const rebatesLoadFileAdded = createAction(
	RebatesLoadActions.RebatesLoadFileAdded
);

export const loadRebatesLoadTemplates = createAction(
	RebatesLoadActions.LoadRebatesLoadTemplates,
	props<ActionResponsePayload<void>>()
);

export const rebatesLoadTemplatesLoaded = createAction(
	RebatesLoadActions.RebatesLoadTemplatesLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const loadRebateLoadFileOptions = createAction(
	RebatesLoadActions.LoadRebateLoadFilesOptions,
	props<ActionResponsePayload<RebateLoadFilesOptionsRequest>>()
);

export const rebateLoadFileOptionsLoaded = createAction(
	RebatesLoadActions.RebateLoadFilesOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const loadRebateLoadFileDetailedOptions = createAction(
	RebatesLoadActions.LoadRebateLoadFilesDetailedOptions,
	props<ActionRequestPayload<RebateLoadFilesDetailedOptionsRequest>>()
);

export const rebateLoadFileDetailedOptionsLoaded = createAction(
	RebatesLoadActions.RebateLoadFilesDetailedOptionsLoaded,
	props<ActionResponsePayload<RebateLoadFileDetailedListOptionModel[]>>()
);

export const processRebatesLoadFile = createAction(
	RebatesLoadActions.ProcessRebatesLoadFile,
	props<ActionRequestPayload<ProcessRebateLoadFileModel>>()
);

export const rebatesLoadFileProcessed = createAction(
	RebatesLoadActions.RebatesLoadFileProcessed
);

export const loadRebatesLoadTemplateMapping = createAction(
	RebatesLoadActions.LoadRebatesLoadTemplateMapping,
	props<ActionRequestPayload<number>>()
);

export const rebatesLoadTemplateMappingLoaded = createAction(
	RebatesLoadActions.RebatesLoadTemplateMappingLoaded,
	props<ActionResponsePayload<RebatesLoadMappingModel>>()
);

export const saveRebatesLoadTemplate = createAction(
	RebatesLoadActions.SaveRebatesLoadTemplate,
	props<ActionRequestPayload<RebatesLoadTemplateSaveModel>>()
);

export const rebatesLoadTemplateSaved = createAction(
	RebatesLoadActions.RebatesLoadTemplateSaved,
	props<ActionResponsePayload<number>>()
);

export const deleteRebatesLoadTemplate = createAction(
	RebatesLoadActions.DeleteRebatesLoadTemplate,
	props<ActionRequestPayload<RebatesLoadTemplateDeleteModel>>()
);

export const rebatesLoadTemplateDeleted = createAction(
	RebatesLoadActions.RebatesLoadTemplateDeleted
);

export const loadRebatesInvalidRecords = createAction(
	RebatesLoadActions.LoadRebatesInvalidRecords,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebatesLoadInvalidRecordsFilterModel>
		>
	>()
);

export const rebatesInvalidRecordsLoaded = createAction(
	RebatesLoadActions.RebatesInvalidRecordsLoaded,
	props<
		ActionResponsePayload<SearchResponse<InvalidRebateRecordSearchModel>>
	>()
);

export const loadRebatesInvalidRecordsBulkCount = createAction(
	RebatesLoadActions.LoadRebatesInvalidRecordsBulkCount,
	props<ActionRequestPayload<RebateInvalidRecordsCountFilterModel>>()
);

export const rebatesInvalidRecordsBulkCountLoaded = createAction(
	RebatesLoadActions.RebatesInvalidRecordsBulkCountLoaded,
	props<ActionResponsePayload<number>>()
);

export const startRebatesInvalidRecordsFileGeneration = createAction(
	RebatesLoadActions.StartRebatesInvalidRecordsFileGeneration,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebatesLoadInvalidRecordsFilterModel>
		>
	>()
);

export const rebatesInvalidRecordsFileGenerationStarted = createAction(
	RebatesLoadActions.RebatesInvalidRecordsFileGenerationStarted
);

export const loadRebatesGroupedErrors = createAction(
	RebatesLoadActions.LoadRebatesGroupedErrors,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebatesLoadInvalidRecordsFilterModel>
		>
	>()
);

export const clearRebatesErrorsWarnings = createAction(
	RebatesLoadActions.ClearRebatesGroupedErrorsWarnings
);

export const rebatesGroupedErrorsLoaded = createAction(
	RebatesLoadActions.RebatesGroupedErrorsLoaded,
	props<
		ActionResponsePayload<SearchResponse<RebateRecordGroupedErrorsModel>>
	>()
);

export const rebatesGroupedWarningsLoaded = createAction(
	RebatesLoadActions.RebatesGroupedWarningsLoaded,
	props<
		ActionResponsePayload<SearchResponse<RebateRecordGroupedErrorsModel>>
	>()
);

export const startRebateLoadFileInvalidRecordsResolving = createAction(
	RebatesLoadActions.StartRebateLoadFileInvalidRecordsResolving,
	props<ActionRequestPayload<RebateInvalidRecordsResolveModel>>()
);

export const rebatesLoadFileInvalidRecordsResolvingStarted = createAction(
	RebatesLoadActions.RebatesLoadFileInvalidRecordsResolvingStarted
);

export const deleteRebateLoadFileInvalidRecordsByErrorCode = createAction(
	RebatesLoadActions.DeleteRebateLoadFileInvalidRecordsByErrorCode,
	props<ActionRequestPayload<DeleteFileInvalidRecordsByErrorCodeModel>>()
);

export const rebatesLoadFileInvalidRecordsByErrorCodeDeleted = createAction(
	RebatesLoadActions.RebatesLoadFileInvalidRecordsByErrorCodeDeleted
);

export const startRebatesLoadFileReading = createAction(
	RebatesLoadActions.StartRebatesLoadFileReading,
	props<ActionRequestPayload<ReadRebateLoadFileModel>>()
);

export const rebatesLoadFileReadingStarted = createAction(
	RebatesLoadActions.RebatesLoadFileReadingStarted,
	props<ActionResponsePayload<number>>()
);

export const startBulkUpdateInvalidRecords = createAction(
	RebatesLoadActions.StartBulkUpdateInvalidRecords,
	props<
		ActionRequestPayload<
			FilterBulkUpdateRequest<RebatesLoadInvalidRecordsBulkFilterModel>
		>
	>()
);

export const invalidRecordsBulkUpdateStarted = createAction(
	RebatesLoadActions.InvalidRecordsBulkUpdateStarted
);

export const startUpdatedRebatesRecordsValidation = createAction(
	RebatesLoadActions.StartUpdatedRebatesRecordsValidation,
	props<ActionRequestPayload<RebatesInvalidRecordsUpdateModel>>()
);

export const updatedRebatesRecordsValidationStarted = createAction(
	RebatesLoadActions.UpdatedRebatesRecordsValidationStarted,
	props<ActionResponsePayload<number[]>>()
);

export const loadRebatesLoadRecentAggregationOptions = createAction(
	RebatesLoadActions.LoadRebatesLoadRecentAggregationOptions,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadBaseSearchFilterModel>
		>
	>()
);

export const rebatesLoadRecentAggregationOptionsLoaded = createAction(
	RebatesLoadActions.RebatesLoadRecentAggregationOptionsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<RebatesLoadAggregationOptionsGroupModel>
		>
	>()
);

export const loadRebatesLoadRecentConversionOptions = createAction(
	RebatesLoadActions.LoadRebatesLoadRecentConversionOptions,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadBaseSearchFilterModel>
		>
	>()
);

export const rebatesLoadRecentConversionOptionsLoaded = createAction(
	RebatesLoadActions.RebatesLoadRecentConversionOptionsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<RebatesLoadConversionOptionsGroupModel>
		>
	>()
);

export const loadRebateLoadFilePreviousPeriod = createAction(
	RebatesLoadActions.LoadRebateLoadFilePreviousPeriod,
	props<ActionResponsePayload<number>>()
);

export const rebateLoadFilePreviousPeriodLoaded = createAction(
	RebatesLoadActions.RebateLoadFilePreviousPeriodLoaded,
	props<ActionResponsePayload<RebateLoadFilePeriod>>()
);

export const loadNotReviewedLocations = createAction(
	RebatesLoadActions.LoadNotReviewedLocations,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const notReviewedLocationLoaded = createAction(
	RebatesLoadActions.NotReviewedLocationLoaded,
	props<
		ActionResponsePayload<SearchResponse<UnmappedRebateLoadLocationModel>>
	>()
);

export const loadCustomerLocations = createAction(
	RebatesLoadActions.LoadCustomerLocations,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const customerLocationLoaded = createAction(
	RebatesLoadActions.CustomerLocationLoaded,
	props<
		ActionResponsePayload<SearchResponse<CustomerRebateLoadLocationModel>>
	>()
);

export const loadMissingLocations = createAction(
	RebatesLoadActions.LoadMissingLocations,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadBaseSearchFilterModel>
		>
	>()
);

export const missingLocationsLoaded = createAction(
	RebatesLoadActions.MissingLocationsLoaded,
	props<
		ActionResponsePayload<
			SearchResponse<RebateLoadMissingLocationSearchModel>
		>
	>()
);

export const excludeLocations = createAction(
	RebatesLoadActions.ExcludeLocations,
	props<ActionRequestPayload<ExcludeLocationsModel>>()
);

export const locationExcluded = createAction(
	RebatesLoadActions.LocationExcluded
);

export const locationsExcluded = createAction(
	RebatesLoadActions.LocationsExcluded
);

export const startAllLocationsExcluding = createAction(
	RebatesLoadActions.StartAllLocationsExcluding,
	props<ActionRequestPayload<ExcludeAllCustomerLocationsModel>>()
);

export const allLocationsExcludingStarted = createAction(
	RebatesLoadActions.AllLocationsExcludingStarted
);

export const checkLocationsBulkActionLoading = createAction(
	RebatesLoadActions.CheckLocationsBulkActionLoading,
	props<ActionRequestPayload<number>>()
);

export const locationsBulkActionLoadingChecked = createAction(
	RebatesLoadActions.LocationsBulkActionLoadingChecked,
	props<ActionRequestPayload<CheckResultModel>>()
);

export const locationsBulkOperationFinished = createAction(
	RebatesLoadActions.LocationsBulkOperationFinished
);

export const startNotReviewedLocationsFileGeneration = createAction(
	RebatesLoadActions.StartNotReviewedLocationsFileGeneration,
	props<ActionRequestPayload<number[]>>()
);

export const notReviewedLocationsFileGenerationStarted = createAction(
	RebatesLoadActions.NotReviewedLocationsFileGenerationStarted
);

export const validateRebateLoadFile = createAction(
	RebatesLoadActions.ValidateRebateLoadFile,
	props<ActionRequestPayload<RebateLoadFileValidationModel>>()
);

export const rebateLoadFileValidated = createAction(
	RebatesLoadActions.RebateLoadFileValidated
);

export const updateRebateLoadMapping = createAction(
	RebatesLoadActions.UpdateRebateLoadMapping,
	props<ActionRequestPayload<UpdateMappingModel>>()
);

export const rebateLoadMapping = createAction(
	RebatesLoadActions.RebateLoadMappingUpdated
);

export const suggestRebateLoadMapping = createAction(
	RebatesLoadActions.SuggestRebateLoadMapping,
	props<ActionRequestPayload<number>>()
);

export const rebateLoadMappingSuggestionStarted = createAction(
	RebatesLoadActions.RebateLoadMappingSuggestionStarted
);

export const suggestRebateLoadConversion = createAction(
	RebatesLoadActions.SuggestRebateLoadConversion,
	props<ActionRequestPayload<number[]>>()
);

export const rebateLoadConversionSuggestionStarted = createAction(
	RebatesLoadActions.RebateLoadConversionSuggestionStarted
);

export const loadSuggestedMapping = createAction(
	RebatesLoadActions.LoadSuggestedMapping,
	props<ActionRequestPayload<number>>()
);

export const rebateLoadMappingSuggestionLoaded = createAction(
	RebatesLoadActions.RebateLoadMappingSuggestionLoaded,
	props<ActionResponsePayload<RebateLoadMappingSuggestionModel>>()
);

export const setTableFilters = createAction(
	RebatesLoadActions.SetTableFilters,
	props<ActionRequestPayload<RebatesLoadFileSearchFilterModel>>()
);

export const tableFiltersSet = createAction(
	RebatesLoadActions.TableFiltersSet,
	props<ActionResponsePayload<RebatesLoadFileSearchFilterModel>>()
);

export const loadConversionHistory = createAction(
	RebatesLoadActions.LoadConversionHistory,
	props<ActionRequestPayload<number[]>>()
);

export const conversionHistoryLoaded = createAction(
	RebatesLoadActions.ConversionHistoryLoaded,
	props<ActionResponsePayload<ConversionHistoryModel>>()
);

export const startFileDuplicatesFileGeneration = createAction(
	RebatesLoadActions.StartFileDuplicatesFileGeneration,
	props<
		ActionRequestPayload<RebateLoadMultiprocessingBaseSearchFilterModel>
	>()
);

export const fileDuplicatesFileGenerationStarted = createAction(
	RebatesLoadActions.FileDuplicatesFileGenerationStarted
);

export const startDuplicatesFileGeneration = createAction(
	RebatesLoadActions.StartDuplicatesFileGeneration,
	props<
		ActionRequestPayload<RebateLoadMultiprocessingBaseSearchFilterModel>
	>()
);

export const duplicatesFileGenerationStarted = createAction(
	RebatesLoadActions.DuplicatesFileGenerationStarted
);

export const revalidateRebateLoadFileRecords = createAction(
	RebatesLoadActions.RevalidateRebateLoadFileRecords,
	props<ActionRequestPayload<number[]>>()
);

export const loadUnknownJCodeDetails = createAction(
	RebatesLoadActions.LoadUnknownJCodeDetails,
	props<ActionRequestPayload<number[]>>()
);

export const unknownJCodeDetailsLoaded = createAction(
	RebatesLoadActions.UnknownJCodeDetailsLoaded,
	props<ActionResponsePayload<UnknownJCodeDetailsModel>>()
);

export const recoveryJCodes = createAction(
	RebatesLoadActions.RecoveryJCodes,
	props<ActionRequestPayload<RecoveryJCodesModel>>()
);

export const jCodesRecovered = createAction(
	RebatesLoadActions.JCodesRecovered,
	props<ActionRequestPayload<RecoveryJCodesModel>>()
);

export const recoveryNdcJCodeCoefficients = createAction(
	RebatesLoadActions.RecoveryNdcJCodeCoefficients,
	props<ActionRequestPayload<RecoveryNdcJCodeCoefficientsModel>>()
);

export const ndcJCodeCoefficientsRecovered = createAction(
	RebatesLoadActions.NdcJCodeCoefficientsRecovered,
	props<ActionRequestPayload<RecoveryNdcJCodeCoefficientsModel>>()
);

export const loadNdcJCodeExclusions = createAction(
	RebatesLoadActions.LoadNdcJCodeExclusions,
	props<ActionRequestPayload<NdcJCodeExclusionSearchModel>>()
);

export const ndcJCodeExclusionsLoaded = createAction(
	RebatesLoadActions.NdcJCodeExclusionsLoaded,
	props<ActionResponsePayload<NdcJCodeExclusionModel[]>>()
);

export const updateNdcJCodeExclusions = createAction(
	RebatesLoadActions.UpdateNdcJCodeExclusions,
	props<ActionRequestPayload<UpdateNdcJCodeExclusionsModel>>()
);

export const ndcJCodeExclusionsUpdated = createAction(
	RebatesLoadActions.NdcJCodeExclusionsUpdated
);

export const rebateLoadFileRecordsRevalidated = createAction(
	RebatesLoadActions.RebateLoadFileRecordsRevalidated
);

export const loadFileMappingPreview = createAction(
	RebatesLoadActions.LoadFileMappingPreview,
	props<
		ActionRequestPayload<FilterSearchRequest<MappingPreviewFilterModel>>
	>()
);

export const fileMappingPreviewLoaded = createAction(
	RebatesLoadActions.FileMappingPreviewLoaded,
	props<ActionResponsePayload<SearchResponse<unknown>>>()
);

export const loadExtensionMappingConfig = createAction(
	RebatesLoadActions.LoadExtensionMappingConfig,
	props<ActionRequestPayload<number>>()
);

export const extensionMappingConfigLoaded = createAction(
	RebatesLoadActions.ExtensionMappingConfigLoaded,
	props<ActionResponsePayload<ExtensionMappingConfigModel>>()
);

export const clearRebateLoadIndicator = createAction(
	RebatesLoadActions.ClearRebateLoadIndicator
);

export const markFilteredRecordsAsDeleted = createAction(
	RebatesLoadActions.MarkFilteredRecordsAsDeleted,
	props<ActionRequestPayload<MarkFilteredAsDeletedModel>>()
);

export const filteredRecordsMarkedAsDeleted = createAction(
	RebatesLoadActions.FilteredRecordsMarkedAsDeleted
);

export const loadAberrantQuantityRecordsCounts = createAction(
	RebatesLoadActions.LoadAberrantQuantityRecordsCounts,
	props<ActionRequestPayload<RebateLoadConvertedSearchFilterModel>>()
);

export const aberrantQuantityRecordsCountsLoaded = createAction(
	RebatesLoadActions.AberrantQuantityRecordsCountsLoaded,
	props<ActionResponsePayload<AberrantQuantityRecordsCountsModel>>()
);

export const resolveAberrantQuantityRecords = createAction(
	RebatesLoadActions.ResolveAberrantQuantityRecords,
	props<ActionRequestPayload<ResolveAberrantQuantityRecordsModel>>()
);

export const aberrantQuantityRecordsResolved = createAction(
	RebatesLoadActions.AberrantQuantityRecordsResolved,
	props<ActionResponsePayload<RecordsValidationResultModel>>()
);

export const resolveFilteredAberrantQuantityRecords = createAction(
	RebatesLoadActions.ResolveFilteredAberrantQuantityRecords,
	props<ActionRequestPayload<ResolveFilteredAberrantQuantityRecordsModel>>()
);

export const filteredAberrantQuantityRecordsResolved = createAction(
	RebatesLoadActions.FilteredAberrantQuantityRecordsResolved
);

export const loadCurrentFileMapping = createAction(
	RebatesLoadActions.LoadCurrentFileMapping,
	props<ActionRequestPayload<number>>()
);

export const currentFileMappingLoaded = createAction(
	RebatesLoadActions.CurrentFileMappingLoaded,
	props<ActionResponsePayload<RebatesLoadMappingModel>>()
);

export const loadFileSheets = createAction(
	RebatesLoadActions.LoadFileSheets,
	props<ActionRequestPayload<number>>()
);

export const fileSheetsLoaded = createAction(
	RebatesLoadActions.FileSheetsLoaded,
	props<ActionResponsePayload<RebateLoadFileSheetModel[]>>()
);

export const checkFileLocationsValid = createAction(
	RebatesLoadActions.CheckFileLocationsValid,
	props<ActionRequestPayload<CheckFilesLocationsValidRequestModel>>()
);

export const fileLocationsValidChecked = createAction(
	RebatesLoadActions.FileLocationsValidChecked,
	props<ActionResponsePayload<CheckResultModel>>()
);

export const checkFileDefinitionsResolved = createAction(
	RebatesLoadActions.CheckFileDefinitionsResolved,
	props<ActionRequestPayload<number>>()
);

export const fileDefinitionsResolvedChecked = createAction(
	RebatesLoadActions.FileDefinitionsResolvedChecked,
	props<ActionResponsePayload<CheckResultModel>>()
);

export const validatePharmacyIdItems = createAction(
	RebatesLoadActions.ValidatePharmacyIdItems,
	props<ActionRequestPayload<number[]>>()
);

export const pharmacyIdItemsValidated = createAction(
	RebatesLoadActions.PharmacyIdItemsValidated,
	props<ActionResponsePayload<number[]>>()
);

export const loadNotReviewedPharmacyIdItems = createAction(
	RebatesLoadActions.LoadNotReviewedPharmacyIdItems,
	props<
		ActionRequestPayload<
			FilterSearchRequest<PharmacyIdNotReviewedGroupsFilterModel>
		>
	>()
);

export const notReviewedPharmacyIdReviewItemsLoaded = createAction(
	RebatesLoadActions.NotReviewedPharmacyIdReviewItemsLoaded,
	props<
		ActionResponsePayload<SearchResponse<NotReviewedPharmacyIdSearchModel>>
	>()
);

export const loadNotReviewedPharmacyIdItemsAvailableActions = createAction(
	RebatesLoadActions.LoadNotReviewedPharmacyIdItemsAvailableActions,
	props<
		ActionRequestPayload<
			FilterSearchRequest<PharmacyIdNotReviewedGroupsFilterModel>
		>
	>()
);

export const notReviewedPharmacyIdReviewItemsAvailableActionsLoaded =
	createAction(
		RebatesLoadActions.NotReviewedPharmacyIdReviewItemsAvailableActionsLoaded,
		props<ActionResponsePayload<PharmacyIdReviewActionModel[]>>()
	);

export const loadReviewedPharmacyIdItems = createAction(
	RebatesLoadActions.LoadReviewedPharmacyIdItems,
	props<
		ActionRequestPayload<
			FilterSearchRequest<RebateLoadMultiprocessingBaseSearchFilterModel>
		>
	>()
);

export const reviewedPharmacyIdReviewItemsLoaded = createAction(
	RebatesLoadActions.ReviewedPharmacyIdReviewItemsLoaded,
	props<ActionResponsePayload<SearchResponse<ReviewedPharmacyIdItemModel>>>()
);

export const executePharmacyIdReviewBulkAction = createAction(
	RebatesLoadActions.ExecutePharmacyIdReviewBulkAction,
	props<ActionRequestPayload<ExecutePharmacyIdBulkReviewActionModel>>()
);

export const pharmacyIdReviewBulkActionExecuted = createAction(
	RebatesLoadActions.PharmacyIdReviewBulkActionExecuted
);

export const changeSubmissionPeriod = createAction(
	RebatesLoadActions.ChangeSubmissionPeriod,
	props<ActionRequestPayload<ChangeSubmissionPeriodRequest>>()
);

export const submissionPeriodChanged = createAction(
	RebatesLoadActions.SubmissionPeriodChanged
);

export const rebateLoadStatusUpdated = createAction(
	RebatesLoadActions.RebateLoadStatusUpdatedEvent,
	props<ActionResponsePayload<RebateLoadStatusChangedNotification>>()
);

export const rebateLoadFileCreated = createAction(
	RebatesLoadActions.RebateLoadFileCreatedEvent,
	props<ActionResponsePayload<RebateLoadFileCreatedNotification>>()
);

export const rebateLoadStatisticUpdated = createAction(
	RebatesLoadActions.RebateLoadStatisticUpdatedEvent,
	props<ActionResponsePayload<RebateLoadStatisticUpdatedNotification>>()
);

export const rebateLoadMappingSuggested = createAction(
	RebatesLoadActions.RebateLoadMappingSuggestedEvent,
	props<ActionResponsePayload<RebateLoadMappingSuggestedNotification>>()
);

export const rebateLoadConversionSuggested = createAction(
	RebatesLoadActions.RebateLoadConversionSuggestedEvent,
	props<ActionResponsePayload<RebateLoadConversionSuggestedNotification>>()
);

export const rollbackRebateLoadFile = createAction(
	RebatesLoadActions.RollbackRebateLoadFile,
	props<ActionRequestPayload<FileRollbackModel>>()
);

export const rebateLoadFileRolledBack = createAction(
	RebatesLoadActions.RebateLoadFileRolledBack
);

export const setFinalReviewForRebateLoadFile = createAction(
	RebatesLoadActions.ExecuteSetFinalReviewForRebateLoadFile,
	props<ActionRequestPayload<ProcessRebateLoadFileModel>>()
);

export const setFinalReviewForRebateLoadFileExecuted = createAction(
	RebatesLoadActions.SetFinalReviewForRebateLoadFileExecuted
);

export const errorOccurred = createAction(RebatesLoadActions.ErrorOccurred);
